import { TabBar, TabbedView } from "component/tabs";
import { UtilityText } from "component/text";
import { VertBox } from "component/basics";
import { useState } from "react";
import { component, demoFile, story, CLICK, CHECK_TEXT, WITHIN } from "system/demo";
import { t } from "util/stdtypes";

demoFile('component/tabs', {
    designUrl: 'https://www.figma.com/design/MX0AcO8d0ZlCBs4e9vkl5f/PSI-Design-System?node-id=6295-30850&t=bTa4b63SZNxxOVuS-0'
});

const tabs = [
    {
        label: t('Top'),
        key: 'top',
        component: () => <UtilityText label={t("Top")} />
    },
    {
        label: t('All'),
        key: 'all',
        component: () => <UtilityText label={t("All")} />
    }
]

function TabBarDemo() {
    const [selectedTabKey, setSelectedTabKey] = useState('top');
    return <TabBar tabs={tabs} selectedTabKey={selectedTabKey} onSelectTab={setSelectedTabKey} />
}

function TabbedViewDemo() {
    const [selectedTabKey, setSelectedTabKey] = useState('top');
    const [current, setCurrent] = useState('top');
    const demoTabs = tabs.map(tab => ({
        ...tab,
        onShow: () => setCurrent(tab.key)
    }));
    return <VertBox gap={8}>
        <TabbedView tabs={demoTabs} selectedTabKey={selectedTabKey} onSelectTab={setSelectedTabKey} />
        <UtilityText testID='current-tab' text={current} />
    </VertBox>;
}

component('TabBar', TabBarDemo, {}, [
    story('Select All', [CLICK('tab-all')])
]);

component('TabbedView', TabbedViewDemo, {}, [
    story('Switch Tabs', [
        WITHIN('current-tab', CHECK_TEXT('top')),
        CLICK('tab-all'),
        WITHIN('current-tab', CHECK_TEXT('all'))
    ])
]);
